export const APPLICATION_DRAWER_WIDTH = 256;
export const NAV_BAR_WIDTH = 320;